import * as React from "react";
import {
    List, Datagrid, TextField, NumberField, EditButton, ShowButton, Edit, Create, Show,
    SimpleForm, SimpleShowLayout, TextInput, SelectInput, NumberInput, BooleanInput,
    DateField, Filter, DeleteButton, ImageField, required
} from 'react-admin';
import { UpLoadFile, FirstImageField } from '../components/custom/UpLoadFile';

const ProviderFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索名称/联系人/电话" source="key" alwaysOn />
        <SelectInput label="资质状态" source="QualificationStatus" choices={[
            { id: 'pending', name: '待审核' },
            { id: 'approved', name: '已通过' },
            { id: 'rejected', name: '已驳回' },
        ]} />
        <SelectInput label="服务类型" source="ServiceType" choices={[
            { id: '农机', name: '农机' },
            { id: '植保', name: '植保' },
            { id: '飞防', name: '飞防' },
            { id: '托管', name: '托管' },
        ]} />
    </Filter>
);

export const AgriServiceProviderList = props => (
    <List {...props} filters={<ProviderFilter />} title="服务主体管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Name" label="主体名称" />
            <TextField source="ContactPerson" label="联系人" />
            <TextField source="Phone" label="联系电话" />
            <TextField source="ProviderType" label="主体类型" />
            <TextField source="ServiceType" label="服务类型" />
            <TextField source="QualificationStatus" label="资质状态" />
            <TextField source="CreditLevel" label="信用等级" />
            <NumberField source="Rating" label="评分" />
            <TextField source="District" label="区县" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <EditButton />
            <ShowButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const AgriServiceProviderShow = props => (
    <Show {...props} title="服务主体详情">
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Name" label="主体名称" />
            <TextField source="ContactPerson" label="联系人" />
            <TextField source="Phone" label="联系电话" />
            <TextField source="Address" label="地址" />
            <TextField source="Province" label="省份" />
            <TextField source="City" label="城市" />
            <TextField source="District" label="区县" />
            <TextField source="ServiceType" label="服务类型" />
            <TextField source="ProviderType" label="主体类型" />
            <TextField source="QualificationStatus" label="资质状态" />
            <TextField source="CreditLevel" label="信用等级" />
            <TextField source="Rating" label="评分" />
            <TextField source="ServiceCount" label="服务次数" />
            <TextField source="AuditRemark" label="审核备注" />
            <DateField source="AuditTime" label="审核时间" showTime />
            <DateField source="CreateTime" label="创建时间" showTime />
        </SimpleShowLayout>
    </Show>
);

export const AgriServiceProviderEdit = props => (
    <Edit {...props} title="编辑服务主体">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Name" label="主体名称" />
            <TextInput source="ContactPerson" label="联系人" />
            <TextInput source="Phone" label="联系电话" />
            <TextInput source="Address" label="地址" />
            <TextInput source="Province" label="省份" />
            <TextInput source="City" label="城市" />
            <TextInput source="District" label="区县" />
            <SelectInput source="ServiceType" label="服务类型" choices={[
                { id: '农机', name: '农机' },
                { id: '植保', name: '植保' },
                { id: '飞防', name: '飞防' },
                { id: '托管', name: '托管' },
            ]} />
            <SelectInput source="ProviderType" label="主体类型" choices={[
                { id: '合作社', name: '合作社' },
                { id: '农机公司', name: '农机公司' },
                { id: '家庭农场', name: '家庭农场' },
            ]} />
            <TextInput source="LicenseImage" label="营业执照URL" />
            <TextInput source="Description" label="简介" multiline />
            <SelectInput source="CreditLevel" label="信用等级" choices={[
                { id: 'A', name: 'A级' },
                { id: 'B', name: 'B级' },
                { id: 'C', name: 'C级' },
                { id: 'D', name: 'D级' },
            ]} />
            <SelectInput source="QualificationStatus" label="资质状态" choices={[
                { id: 'pending', name: '待审核' },
                { id: 'approved', name: '已通过' },
                { id: 'rejected', name: '已驳回' },
            ]} />
            <TextInput source="AuditRemark" label="审核备注" multiline />
            <NumberInput source="Longitude" label="经度" />
            <NumberInput source="Latitude" label="纬度" />
            <BooleanInput source="Open" label="启用" />
        </SimpleForm>
    </Edit>
);

export const AgriServiceProviderCreate = props => (
    <Create {...props} title="新建服务主体">
        <SimpleForm>
            <TextInput source="Name" label="主体名称" validate={required()} />
            <TextInput source="ContactPerson" label="联系人" />
            <TextInput source="Phone" label="联系电话" />
            <TextInput source="Address" label="地址" />
            <TextInput source="Province" label="省份" />
            <TextInput source="City" label="城市" />
            <TextInput source="District" label="区县" />
            <SelectInput source="ServiceType" label="服务类型" choices={[
                { id: '农机', name: '农机' },
                { id: '植保', name: '植保' },
                { id: '飞防', name: '飞防' },
                { id: '托管', name: '托管' },
            ]} />
            <SelectInput source="ProviderType" label="主体类型" choices={[
                { id: '合作社', name: '合作社' },
                { id: '农机公司', name: '农机公司' },
                { id: '家庭农场', name: '家庭农场' },
            ]} />
            <TextInput source="LicenseImage" label="营业执照URL" />
            <TextInput source="Description" label="简介" multiline />
            <NumberInput source="Longitude" label="经度" />
            <NumberInput source="Latitude" label="纬度" />
            <BooleanInput source="Open" label="启用" defaultValue={true} />
        </SimpleForm>
    </Create>
);
